import { useMutation } from "@tanstack/react-query";

import { ModelsReadNotificationsRequest, PatchApiInternalNotifications200 } from "@/schemas";
import { patchApiInternalNotifications } from "@/shared/api/auth";
import { CustomAxiosError } from "@/shared/model/types/axiosError";

export const useReadNotifications = () => {
    return useMutation<
        PatchApiInternalNotifications200,
        CustomAxiosError,
        ModelsReadNotificationsRequest
    >({
        mutationKey: ["readNotifications"],
        mutationFn: ({ uuids }) => patchApiInternalNotifications({ uuids }),
        retry: 0,
    });
};
